import TYPES from '@/types';
import Vue from 'vue';
import { currencyFormat } from '@/vue-app/utils/currency';

// Application
import GetGoalEarningsQuery from '@/modules/flagship/investor-goal/earnings/application/queries/get-goal-earnings-query';

// Domain
import Inject from '@/modules/shared/domain/di/inject';
import { MessageNotifier } from '@/modules/shared/domain/notifiers/message_notifier';
import Translator from '@/modules/shared/domain/i18n/translator';
import { Values } from '@/modules/shared/domain/i18n/types';

type Coordinate = {
  x: string;
  y: number;
}

export default class GoalEarningsViewModel {
  @Inject(TYPES.GET_GOAL_EARNINGS_QUERY)
  private readonly get_goal_earnings!: GetGoalEarningsQuery

  @Inject(TYPES.NOTIFIER)
  private readonly message_notifier!: MessageNotifier

  @Inject(TYPES.I18N)
  private readonly translator!: Translator

  private readonly view!: Vue;

  readonly i18n_namespace = 'components.goals-dashboard.details-goals.goal-earnings';

  is_loading = false;

  color_title = 'primary--text';

  earnings_percentage = 0

  chart_series: Array<any> = [];

  chart_options = {
    chart: {
      type: 'area',
      height: 350,
      stacked: true,
      parentHeightOffset: 0,
      toolbar: {
        show: false,
      },
      zoom: {
        enabled: true,
      },
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      curve: 'smooth',
    },
    xaxis: {
      labels: {
        style: {
          colors: '#8F9EC9',
        },
      },
    },
    yaxis: {
      labels: {
        style: {
          colors: '#8F9EC9',
        },
        formatter(value: number) {
          return `${currencyFormat(value)} MXN`;
        },
      },
    },
    tooltip: {
      style: {
        color: '#000000',
      },
      fixed: {
        enabled: false,
        position: 'topRight',
      },
    },
    colors: ['#64D0E0'],
  };

  public constructor(
    view: Vue,
  ) {
    this.view = view;
  }

  translate = (message: string, values?: Values) => this.translator.translate(`${this.i18n_namespace}.${message}`, values);

  parseNumberToCurrency = (value: number) => `${currencyFormat(value)} MXN`

  changeColorSwsModerate = () => {
    this.color_title = 'white--text';
    this.chart_options.yaxis.labels.style.colors = '#FFFFFF';
    this.chart_options.yaxis.labels.style.colors = '#FFFFFF';
  }

  loadEarnings = async (investor_goal_id: string) => {
    const earnings_chart_report: Array<Coordinate> = [];
    const goal_earnings = await this.get_goal_earnings.execute(investor_goal_id);
    this.earnings_percentage = goal_earnings.earnings_percentage;
    goal_earnings.earnings.forEach((goal_earning) => {
      earnings_chart_report.push(
        { x: goal_earning.period, y: goal_earning.goal_balance },
      );
    });
    this.chart_series.push({
      name: this.translate('total_amount'),
      data: earnings_chart_report,
    });
  }

  initialize = async (
    strategy_option: string, investor_goal_id: string,
  ) => {
    if (strategy_option === 'moderate') {
      this.changeColorSwsModerate();
    }
    await this.loadEarnings(investor_goal_id);
  }
}
